module.exports = __webpack_public_path__ + "static/Alex-c7e91e84991f4427fa2d0aeb0206d2f2.jpg";